import React, { memo } from 'react';
import { cx } from '@emotion/css';
import styled from '@emotion/styled';

import { Gray_Light_200, Gray_Light_900, type TypographyType } from '@common/styles';
import { displayPrice } from '@common/utils';

export interface PriceProps {
  price: number | null;
  color?: string;
  scale_type?: TypographyType;
  className?: string;
  disabled?: boolean;
  prefix?: string;
  ariaLabel?: string;
}

export const Price = memo(({ price, color, scale_type, className, disabled, prefix = '', ariaLabel }: PriceProps) => {
  if (price === null) {
    return null;
  }

  return (
    <PriceWrapper className={cx(className, scale_type)} color={color} disabled={disabled} aria-label={ariaLabel}>
      {prefix}
      {displayPrice(price)}
    </PriceWrapper>
  );
});

const PriceWrapper = styled.span<{ disabled?: boolean; color?: string }>`
  display: inline-flex;
  word-break: break-all;
  color: ${({ disabled, color }) => {
    if (disabled) {
      return Gray_Light_200;
    }
    return color ?? Gray_Light_900;
  }};
`;
